import { render } from "./Typewriter.svg?vue&type=template&id=7d16c688"
const script = {}
script.render = render

export default script